import { log } from "./logger";

const EMBED_MODE_QUERY_PARAM = "embed";

function shouldEnableEmbeddedModeFromLocation(): boolean {
    if (window.location.pathname.startsWith("/embed/")) {
        return true;
    }

    const embedModeParamValue = new URLSearchParams(window.location.search).get(EMBED_MODE_QUERY_PARAM);
    return embedModeParamValue === "true";
}

/**
 * We want to track when users are navigating in the embedded mode (in iframe).
 * Checking the URL is not enough because after navigation to another page it won't have "/embed/" in the URL.
 * We also support `?embed=true` for embedding full apps/pages.
 * */
if (shouldEnableEmbeddedModeFromLocation()) {
    try {
        window.sessionStorage.setItem("embeddedMode", "true");
    } catch (error) {
        log.warn("Failed to save 'embeddedMode' value to sessionStorage", error);
    }
}

export const embeddedMode = window.sessionStorage.getItem("embeddedMode") === "true";
